module.exports = __webpack_public_path__ + "static/media/css.534656a4.png";